module.exports = __webpack_public_path__ + "img/f9cb6c5c8c0e03e0ff8b1e12fe06d245.png";